// extracted by mini-css-extract-plugin
export default {"Label":"_Label--vlcRS","SelectTrigger":"_SelectTrigger--Obw_l","Loading":"_Loading--I1fTx"};